import React, { useState, useEffect } from "react";
import Trending from "../trending/Trending.jsx";
import { Row, Col, Card, CardImg, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Spinner from "../utilities/Spinner.jsx";
import useFetch from "../hooks/useFetch";

function ArticleList() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const articles = useFetch("articles/");

    function getArticleUrl(article_id) {
        let articleUrl = '/article/' + article_id + '/';
        return articleUrl;
    }

    return (
        <Container className="pt-4">
            <h2 style={{ fontStyle:'italic' }}>Articles</h2>
            {!articles ? (
                <Spinner />
            ) : (
                <Row>
                    <Col sm={12}>
                        <Row>
                            {articles.map((article) => {
                                return (
                                    <Col
                                        sm={4}
                                        className="my-4"
                                        key={article.id}
                                        data-aos="fade-up"
                                    >
                                        <NavLink to={getArticleUrl(article.id)} className="text-dark d-block">
                                            <Card>
                                                <CardImg
                                                    src={`${article.image.replace("media", "static")}`}
                                                />
                                                <Card.Body>
                                                    <Card.Title>{article.title}</Card.Title>
                                                    <Card.Text>
                                                        {article.content.substring(0, 50) + '...'}
                                                    </Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </NavLink>

                                    </Col>
                                );
                            })}
                        </Row>
                    </Col>
                </Row>
            )}    </Container>
    );
}

export default ArticleList;
